import {
    ANSWER_SUMMARY_CONFIG
} from '@stylesheet/brands/ikh/admin/themes/dark/AnswerSummaryConfig'
import { BOOTSTRAP_CONFIG } from '@stylesheet/brands/ikh/admin/themes/dark/BootstrapConfig'
import {
    CAREPROFESSIONAL_DASHBOARD_CONFIG
} from '@stylesheet/brands/ikh/admin/themes/dark/CareprofessionalDashboardConfig'
import {
    FACILITY_MANAGEMENT_CONFIG
} from '@stylesheet/brands/ikh/admin/themes/dark/FacilityManagementConfig'
import { GLOBAL_CONFIG } from '@stylesheet/brands/ikh/admin/themes/dark/GlobalConfig'
import { ThemeConfig } from '@stylesheet/config/ThemeConfig'

export const THEME_CONFIG: ThemeConfig = {
    global: GLOBAL_CONFIG,
    bootstrap: BOOTSTRAP_CONFIG,
    admin: {
        answerSummary: ANSWER_SUMMARY_CONFIG,
        careprofDashboard: CAREPROFESSIONAL_DASHBOARD_CONFIG,
        fmt: FACILITY_MANAGEMENT_CONFIG
    }
}
